<template>
  <div class="service-file-list-item">
    <div class="top">
      <div v-if="item.type === 'IMAGE'">
        <a data-fancybox="gallery" class="image" :href="util.getImageUrl(item.url, '1000-')">
          <img :src="util.getImageUrl(item.url, '180x180')" />
        </a>
      </div>
      <div v-else-if="item.type === 'VIDEO'">
        <img :src="util.getImageUrl(item.url, '180x180')" alt />
      </div>
      <div v-else-if="item.type === 'AUDIO'">
        <img src="@/assets/service/文档.png" />
      </div>
      <div v-else-if="item.type === 'PDF'">
        <img src="@/assets/service/音符.png" />
      </div>
    </div>
    <div class="bottom">
      <div v-if="item.type === 'IMAGE'">{{item.name}}</div>
      <div v-else-if="item.type === 'VIDEO'">
        <img src="@/assets/service/视频.png" /> 视频
      </div>
      <div v-else-if="item.type === 'AUDIO'">
        <img src="@/assets/service/音频.png" /> 音频
      </div>
      <div v-else-if="item.type === 'PDF'">
        <img src="@/assets/service/pdf.png" /> PDF
      </div>
      <div class="download" @click="onDownload"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileListItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    onDownload() {
      // const src = this.util.getImageUrl(this.item.url);

      // window.open(src);

      let url = "";
      if (process.env.NODE_ENV === "development") {
        url =
          "http://localhost:8080/api/marketing/commodityMarketing/downloadFile?url=" +
          this.item.url;
      } else {
        url =
          "http://fresh-wiki.yonghui.cn/api/marketing/commodityMarketing/downloadFile?url=" +
          this.item.url;
      }

      window.open(url);
    }
  }
};
</script>

<style lang="scss">
.service-file-list-item {
  width: 180px;
  height: 180px;
  border-radius: 5px;

  .controls {
    background: rgba(0, 0, 0, 1);
    opacity: 0.7;
    cursor: pointer;
    position: absolute;
    width: 50px;
    height: 50px;
    z-index: 2;

    left: 65px;
    top: 45px;

    border-radius: 50%;

    img {
      width: 14px;
      height: 17px;
      margin: 18px 17px 16px 18px;
    }
  }

  .top {
    width: 180px;
    height: 143px;
  }

  .bottom {
    width: 180px;
    height: 37px;
    line-height: 37px;

    background: #eee;

    opacity: 0.9;

    div {
      width: 145px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);

      vertical-align: middle;
      display: inline-block;
      margin-left: 10px;

      img {
        vertical-align: text-bottom;
        width: 18px;
        height: 18px;
      }
    }

    div.download {
      cursor: pointer;
      margin: 10px 5px 9px 0px;
      width: 18px;
      height: 18px;

      background-size: cover;

      display: inline-block;
      vertical-align: top;

      background-image: url(~/images/单个下载.png);
    }

    div.download:hover {
      background-image: url(~/images/单个下载绿色.png);
    }
  }
}
</style>